import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from 'react-i18next';
import DailyAvalancheRegistrationForm from "./DailyAvalancheRegForm";
import "../ReportEnhanced.css";

const DailyAvalancheForm = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {

    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: <DMSHeader title={'Edit Daily Avalanche Details'} showIconsForback={true} increaseHeaderHeight={true}/>,
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <DailyAvalancheRegistrationForm />,
    },
  ];
  return (
    <div className="report-enhanced-wrapper">
      <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
        <GridItem layoutData={layoutData} />
      </div>
    </div>
  );
};

export default DailyAvalancheForm;

